module.exports = __webpack_public_path__ + "static/assets/5e93e423780d8245ee913171deb3f750.png";